import { useQuery } from "@tanstack/react-query";

import { axios } from "@/admin/libs/axios";

export interface AdminKPI {
  label: string;
  value: number;
  wowDelta: number | null;
  format: "count" | "currency";
}

export interface AdminOverview {
  kpis: AdminKPI[];
  activeCampaigns: Array<{
    slug: string;
    name: string;
    offerType: "FREE_ACCESS" | "STRIPE_DISCOUNT";
    redemptions: number;
    maxRedemptions: number | null;
    startsAt: string;
    endsAt: string;
  }>;
  recentSignups: Array<{ id: string; email: string; name: string; createdAt: string }>;
}

export const fetchAdminOverview = async (): Promise<AdminOverview> => {
  const { data } = await axios.get<AdminOverview>("/admin/overview");
  return data;
};

export const useAdminOverview = () =>
  useQuery({
    queryKey: ["admin", "overview"],
    queryFn: fetchAdminOverview,
    // 30s is a good cadence — the page is glanceable, not live-ops tooling.
    staleTime: 30_000,
    refetchInterval: 60_000,
  });
